// extracted by mini-css-extract-plugin
module.exports =  {"root":"BL855C","icon":"xdF8rv"};